import React, { Component } from 'react';
import LayoutHeader from '../Inc/Header';
import { Alert, Spin, Icon } from 'antd';
import AdminNavigation from '../Inc/AdminNavigation';
import QueryBuilder from './QueryBuilder';
import MyList from './MyList';
import QuickList from './QuickList';
import { Tabs } from 'antd';
import PublicList from './PublicList';
import * as actions from "../../actions/index";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';
import EditAlumni from '../MaintainAlumni';
import LoadingModal from '../Inc/LoadingModal';

const LoadingIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
const TabPane = Tabs.TabPane;
class ListandSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      key: "1",
      cleardata: "",
      PersonGuid:"",
      EditAlumniStatus:false,
      dispaltTable:"flex"
    }

  }

  buildquery = (e) => {
    console.log('values')
  }

  callback = (key, data) => {

    this.setState({
      key: key,
      cleardata: data
    })
    console.log(key);
    if (key == 1) {
      console.log(this.props.match.params.preferencename)
      if (this.props.match.params.preferencename) {
        this.props.actions.getlist(this.props.match.params.preferencename, this.props.match.params.listtype)

      }
      this.render();
      this.forceUpdate();
    }
    this.render();
    this.forceUpdate();
  }

  componentDidMount = () =>{
    let userRole;
    if (this.props.isSuperAlumniAdmin) {
      userRole = "SUPER ADMIN";
    } 
    else if (this.props.isAlumniAdmin) {
      userRole = "ALUMNI ADMIN";
    } 
    else if (this.props.isCSTSupport) {
      userRole = "CST SUPPORT";
      let getLoggedInUserPosition = 'AlumniCSTSupport'
      this.props.actions.getAssignRolesPositions(getLoggedInUserPosition)
    }
    else if (this.props.isCouncilCommittee) {
      userRole = "COUNCIL COMMITTE";
    } 
    else if (this.props.isspecialist) {
      userRole =  "SPECIALIST";
    }

    // this.props.actions.getcompletecolumnlist(userRole); //AAG-1264 Old reports column
    this.props.actions.getNewReportColumn(userRole);
    this.props.actions.isadmin();
    this.props.actions.getEthnicities();
    window.scrollTo(0, 0)
  }

  componentWillReceiveProps = (nextprops) => {

    if ( (nextprops.orgInfoLoading != this.props.orgInfoLoading)) {
      this.setState({showLoadingModal: nextprops.orgInfoLoading});
    }

  }

  getPersonGuid = (PersonGuid) =>{
    console.log(PersonGuid)
    this.setState({
      PersonGuid: PersonGuid,
      EditAlumniStatus: true,
      dispaltTable:"none"
     })
  }
  removeEditAlumni = () =>{
    
    this.setState({
     
      EditAlumniStatus: !this.state.EditAlumniStatus,
      dispaltTable:"flex"
     })
  }

  renderTabs = () => {
    if (this.props.loading || this.props.getNewReportColumnLoading) {
      return <div className='page-center'>
        <Spin indicator={LoadingIcon} className="loading-state" tip="Loading page..." />
      </div>
    }

    
    if (!this.props.error) {
      return <div className='widget-container dashboard-table quick-search query-filter-container'>
        <Tabs activeKey={this.state.key} onChange={this.callback}>
          <TabPane tab="Advanced Search" key="1">
            <QueryBuilder clearValues={this.state.cleardata}  getPersonGuid={this.getPersonGuid}/>
          </TabPane>
          {/* currently hidden for the new search feature */}
          {/* <TabPane tab="My Lists" key="2">
            <MyList callbackchange={this.callback.bind(this)} />
          </TabPane >
          <TabPane tab="Public Lists" key="3">
            <PublicList />
          </TabPane>
          <TabPane tab="Quick Lists" key="4">
            <QuickList />
          </TabPane> */}
        </Tabs>
      </div>
    }
    if (this.props.error) {
      return <div className='page-center'>
        <Alert
          message={this.props.error.ResponseMessage}
          description="You dont have access to run the report"
          type="error"
          showIcon
        />
      </div>
    }
  }

  render() {

    return (
      <div>
        <LayoutHeader />
        <AdminNavigation />
        <div className='widget' style={{display:this.state.dispaltTable}}> {this.renderTabs()} </div>
       {(this.state.EditAlumniStatus && this.state.PersonGuid) &&  <EditAlumni PersonGuid={this.state.PersonGuid} removeEditAlumni={this.removeEditAlumni}/>   }
       
       <LoadingModal visible={this.state.showLoadingModal} />
      </div>
    );
  }

}

function mapStateToProps(state) {
  return {
    loading: state.columnlistreducer.loading,
    error: state.columnlistreducer.error,
    preferencelistloading: state.quickpreferencelistreducer.loading,
    preferencelist: state.quickpreferencelistreducer.preferencelist,

    orgInfoLoading: state.childOrganzationReducer.loading,

    isadmin: state.isadminreducer.isadmin,
    isspecialist: state.isadminreducer.isspecialist,
    isSuperAlumniAdmin: state.isadminreducer.isSuperAlumniAdmin,
    isCSTSupport: state.isadminreducer.isCSTSupport,
    isCouncilCommittee: state.isadminreducer.isCouncilCommittee,
    isAlumniAdmin: state.isadminreducer.isAlumniAdmin,
  }
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  }
}

export default compose(connect(mapStateToProps, mapDispatchToProps), withRouter)(ListandSearch);


// WEBPACK FOOTER //
// ./src/components/ListandAdvancedSearch/index.js